var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36667 6.75C8.18854 6.75 9.66667 5.23828 9.66667 3.375C9.66667 1.51172 8.18854 0 6.36667 0C4.54479 0 3.06667 1.51172 3.06667 3.375C3.06667 5.23828 4.54479 6.75 6.36667 6.75ZM9.3 7.5H8.03729C7.52854 7.73906 6.9625 7.875 6.36667 7.875C5.77083 7.875 5.20708 7.73906 4.69604 7.5H3.43333C1.81313 7.5 0.5 8.84297 0.5 10.5V10.875C0.5 11.4961 0.992708 12 1.6 12H11.1333C11.7406 12 12.2333 11.4961 12.2333 10.875V10.5C12.2333 8.84297 10.9202 7.5 9.3 7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3148 3.33333H13.8333V4.84848H15.3148V3.33333ZM15.0185 0V0.606061H12.6481V0H12.0556V0.606061H11.7593C11.4304 0.606061 11.1696 0.878788 11.1696 1.21212L11.1667 5.45455C11.1667 5.78788 11.4304 6.06061 11.7593 6.06061H15.9074C16.2333 6.06061 16.5 5.78788 16.5 5.45455V1.21212C16.5 0.878788 16.2333 0.606061 15.9074 0.606061H15.6111V0H15.0185ZM15.9074 5.45455H11.7593V2.12121H15.9074V5.45455Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCalendar);
export default __webpack_public_path__ + "static/media/user-calendar.9ae81819d55febd21ae435e6a7d93e3c.svg";
export { ForwardRef as ReactComponent };